<template>
  <div class="CourseList">
    <AppHeader content="课程管理 | 课程列表"></AppHeader>
    <AppBox class="appBox">
      <CourseTable></CourseTable>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import CourseTable from "@/pages/CourseManagement/CourseTable.vue";

export default {
  name: "CourseList",
  components: {CourseTable, AppBox, AppHeader},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.CourseList {
  .appBox {
    height: calc(100vh - 155px);

    .tableFilter {
      padding-bottom: 20px;

      .el-form-item {
        margin-right: 30px;
      }

      ::v-deep .el-range-separator {
        width: 20px !important;
      }
    }

    ::v-deep .el-dropdown-link {
      cursor: pointer;
      color: map-get($colors, primary);
      margin-left: 15px;

      ::v-deep .el-icon-arrow-down {
        font-size: 12px;
      }
    }

    ::v-deep .el-dialog {
      margin-top: 30vh !important;
      width: 450px;
    }

    .footer {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 30px;
    }
  }
}
</style>
